import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  ActivateDeactivateCommands,
  ActiveModeCommands,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsActiveProperty,
  IsNumberValueProperty,
  PropertiesStringValueGeneric,
} from '@vi-iot/client';

import { InstallationFeaturesStore, WallboxChargingModes } from '@store';
import { NO_VALUE } from '@pipes';

import { CustomTranslationsService } from 'src/app/operational-data-common/translations';
import { FeaturesDetailsOverlayTypeEnum } from '../../installation-overlay.model';

@Component({
  selector: 'app-wallbox-charging-mode',
  templateUrl: './wallbox-charging-mode.component.html',
  styleUrls: ['./wallbox-charging-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WallboxChargingModeComponent implements OnInit {
  readonly availableOverlays = FeaturesDetailsOverlayTypeEnum;
  readonly featurePropertyKey = FeaturePropertyKey;

  chargingMode$: Observable<
    Feature<PropertiesStringValueGeneric<WallboxChargingModes>, ActiveModeCommands>
  >;
  chargingLimit$: Observable<Feature<IsNumberValueProperty, never>>;
  vehicleChargingStationAllowBatteryDischarge$: Observable<
    Feature<IsActiveProperty, ActivateDeactivateCommands>
  >;

  modeLabel: string;
  modeIconSource: string;

  constructor(
    protected customTranslationsService: CustomTranslationsService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.vehicleChargingStationAllowBatteryDischarge$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.vehicleChargingStationAllowBatteryDischarge
    );
    this.chargingMode$ = this.installationFeaturesStore
      .selectInstallationDeviceFeature<
        PropertiesStringValueGeneric<WallboxChargingModes>,
        ActiveModeCommands
      >(FeatureNames.wallboxChargingMode)
      .pipe(
        tap((feature) => {
          this.setModeLabelAndIcon(feature?.properties?.value?.value);
        })
      );

    this.chargingLimit$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.wallboxChargingLimit
    );
  }

  private setModeLabelAndIcon(mode: WallboxChargingModes): void {
    switch (mode) {
      case WallboxChargingModes.GREEN:
        this.modeLabel = '+INSTALLATIONS.INSTALLATION.WALLBOX.GREEN_CHARGING_TILE';
        this.modeIconSource = 'assets/icons/wallbox/green-charging-icon.svg';
        break;

      case WallboxChargingModes.MIXED:
        this.modeLabel = '+INSTALLATIONS.INSTALLATION.WALLBOX.MIXED_CHARGING_TILE';
        this.modeIconSource = 'assets/icons/wallbox/mixed-charging-icon.svg';
        break;
      case WallboxChargingModes.SMART:
        this.modeLabel = '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING_TILE';
        this.modeIconSource = 'assets/icons/wallbox/smart-charging-icon.svg';
        break;

      default:
        this.modeLabel = NO_VALUE;
    }
  }
}
